/** Shared theme tokens for Word Wheel mobile prototype (mirrors word-wheel-quest appearance). */

export const wwColors = {
    pageBg: "#f8fafc",
    mainGradient: "linear-gradient(165deg, #c995a8 0%, #e4a89a 42%, #f0b088 78%, #f5c49a 100%)",
    playGradient: "linear-gradient(180deg, #38bdf8 0%, #0284c7 32%, #0c4a6e 68%, #031525 100%)",
    playGradientDark: "linear-gradient(180deg, #22d3ee 0%, #0284c7 32%, #0c4a6e 68%, #020617 100%)",
    surface: "#ffffff",
    surfaceMuted: "rgba(255, 255, 255, 0.72)",
    gridCellHidden: "rgba(56, 189, 248, 0.22)",
    border: "rgba(125, 211, 252, 0.4)",
    borderStrong: "rgba(186, 230, 253, 0.55)",
    text: "#f0f9ff",
    textSecondary: "rgba(224, 242, 254, 0.78)",
    textMuted: "rgba(186, 230, 253, 0.62)",
    textOnSurface: "#0c4a6e",
    accent: "#38bdf8",
    accentDark: "#0ea5e9",
    accentSoft: "rgba(14, 165, 233, 0.22)",
    accentRing: "rgba(56, 189, 248, 0.35)",
    wheelLine: "#fcd34d",
    wheelLineDark: "#f59e0b",
    wheelLineGlow: "rgba(252, 211, 77, 0.5)",
    wheelLineSoft: "rgba(254, 243, 199, 0.9)",
    success: "#34d399",
    successSoft: "rgba(16, 185, 129, 0.28)",
    successText: "#ecfdf5",
    hintSoft: "rgba(251, 191, 36, 0.32)",
    hintText: "#fde68a",
    shadowSm: "0 1px 3px rgba(3, 21, 37, 0.2)",
    shadowMd: "0 4px 16px rgba(3, 21, 37, 0.28)",
};

/**
 * Play — native WW_LIGHT (cyan ocean chrome).
 */
export const wwPlayColorsLight = {
    ...wwColors,
    surface: "rgba(15, 55, 75, 0.72)",
    surfaceMuted: "rgba(224, 242, 254, 0.2)",
    gridCellHidden: "rgba(56, 189, 248, 0.22)",
    gridBorder: "rgba(125, 211, 252, 0.55)",
    gridRevealedBorder: "#7dd3fc",
    gridNumberBorder: "#38bdf8",
    gridNumberText: "#082f49",
    border: "rgba(125, 211, 252, 0.4)",
    borderStrong: "rgba(186, 230, 253, 0.55)",
    text: "#f0f9ff",
    textOnSurface: "#0c4a6e",
    textSecondary: "rgba(224, 242, 254, 0.78)",
    textMuted: "rgba(186, 230, 253, 0.62)",
    accent: "#38bdf8",
    accentDark: "#0ea5e9",
    accentSoft: "rgba(14, 165, 233, 0.22)",
    accentRing: "rgba(56, 189, 248, 0.35)",
    toolBtnBg: "rgba(224, 242, 254, 0.2)",
    toolIcon: "#e0f2fe",
    clueBg: "rgba(8, 47, 73, 0.72)",
    clueText: "#f0f9ff",
    coinLabel: "#e0f2fe",
    letterBg: "rgba(15, 55, 75, 0.78)",
    letterText: "#ffffff",
    letterBorder: "rgba(186, 230, 253, 0.85)",
    letterSelectedBorder: "#fcd34d",
    letterSelectedText: "#78350f",
    selectedBorder: "#fcd34d",
    selectedText: "#78350f",
    selectedSurface: "#fffbeb",
    shadowSm: "0 1px 3px rgba(3, 21, 37, 0.22)",
    shadowMd: "0 4px 16px rgba(3, 21, 37, 0.3)",
};

/**
 * Play — native WW_DARK (deeper ocean chrome).
 */
export const wwPlayColorsDark = {
    ...wwPlayColorsLight,
    surface: "#0c4a6e",
    gridCellHidden: "rgba(56, 189, 248, 0.18)",
    gridBorder: "rgba(125, 211, 252, 0.5)",
    textSecondary: "rgba(224, 242, 254, 0.75)",
    textMuted: "rgba(186, 230, 253, 0.55)",
    textOnSurface: "#082f49",
    accentSoft: "rgba(14, 165, 233, 0.2)",
    wheelLineGlow: "rgba(252, 211, 77, 0.55)",
    hintSoft: "rgba(251, 191, 36, 0.28)",
    toolBtnBg: "rgba(224, 242, 254, 0.18)",
    clueBg: "rgba(2, 6, 23, 0.78)",
    letterBorder: "rgba(125, 211, 252, 0.95)",
};

/** @deprecated Prefer wwPlayColorsLight — alias kept for existing play/settings imports. */
export const wwPlayColors = wwPlayColorsLight;

/**
 * Play — native WW_RANDOM (frosted light chrome over scene photos).
 * Tokens aligned with android-word-wheel-quest `WW_RANDOM`.
 */
export const wwPlayColorsRandom = {
    ...wwColors,
    playGradient: "linear-gradient(180deg, #ffffff 0%, #f8fafc 40%, #f1f5f9 70%, #e2e8f0 100%)",
    surface: "rgba(255, 255, 255, 0.94)",
    surfaceMuted: "rgba(241, 245, 249, 0.9)",
    gridCellHidden: "rgba(204, 251, 241, 0.92)",
    gridBorder: "rgba(110, 231, 183, 0.9)",
    gridRevealedBorder: "#bbf7d0",
    gridNumberBorder: "#059669",
    gridNumberText: "#064e3b",
    border: "rgba(148, 163, 184, 0.4)",
    borderStrong: "rgba(148, 163, 184, 0.65)",
    text: "#0f172a",
    textOnSurface: "#334155",
    textSecondary: "rgba(15, 23, 42, 0.68)",
    textMuted: "rgba(15, 23, 42, 0.45)",
    accent: "#0d9488",
    accentDark: "#0f766e",
    accentSoft: "rgba(241, 245, 249, 0.9)",
    accentRing: "rgba(13, 148, 136, 0.28)",
    wheelLine: "#f59e0b",
    wheelLineDark: "#d97706",
    wheelLineGlow: "rgba(245, 158, 11, 0.45)",
    success: "#059669",
    successSoft: "rgba(167, 243, 208, 0.92)",
    successText: "#065f46",
    hintSoft: "rgba(254, 243, 199, 0.95)",
    hintText: "#92400e",
    toolBtnBg: "rgba(255, 255, 255, 0.95)",
    toolIcon: "#475569",
    clueBg: "rgba(255, 255, 255, 0.94)",
    clueText: "#0f172a",
    coinLabel: "#64748b",
    letterBg: "rgba(255, 255, 255, 0.98)",
    letterText: "#0f172a",
    letterBorder: "rgba(148, 163, 184, 0.85)",
    letterSelectedBorder: "#f59e0b",
    letterSelectedText: "#78350f",
    selectedBorder: "#f59e0b",
    selectedText: "#78350f",
    selectedSurface: "#fffbeb",
    shadowSm: "0 1px 3px rgba(15, 23, 42, 0.08)",
    shadowMd: "0 4px 16px rgba(15, 23, 42, 0.12)",
};

/**
 * Home / settings / daily chrome — soft mint (Android COLORS_LIGHT).
 */
export const wwHomeColorsLight = {
    background: "#e8f5f0",
    surface: "#f3fbf7",
    surfaceLight: "#d8f3e7",
    primary: "#0d9488",
    primaryGlow: "#0f766e",
    accent: "#0d9488",
    accentDark: "#0f766e",
    text: "#064e3b",
    textMuted: "rgba(6, 78, 59, 0.55)",
    textSecondary: "rgba(6, 78, 59, 0.72)",
    border: "rgba(13, 148, 136, 0.18)",
    borderStrong: "rgba(13, 148, 136, 0.28)",
    success: "#059669",
    successSoft: "rgba(5, 150, 105, 0.12)",
    successText: "#065f46",
    shadowSm: "0 1px 3px rgba(6, 78, 59, 0.08)",
    shadowMd: "0 4px 16px rgba(6, 78, 59, 0.12)",
};

/** Home chrome — deep green (Android COLORS_DARK). */
export const wwHomeColorsDark = {
    background: "#0A2925",
    surface: "#153D38",
    surfaceLight: "#1a4a43",
    primary: "#2dd4bf",
    primaryGlow: "#5eead4",
    accent: "#2dd4bf",
    accentDark: "#14b8a6",
    text: "#f0faf6",
    textMuted: "rgba(224, 242, 236, 0.68)",
    textSecondary: "rgba(224, 242, 236, 0.78)",
    border: "rgba(59, 166, 102, 0.28)",
    borderStrong: "rgba(45, 212, 191, 0.35)",
    success: "#34d399",
    successSoft: "rgba(52, 211, 153, 0.18)",
    successText: "#ecfdf5",
    shadowSm: "0 1px 3px rgba(0, 0, 0, 0.28)",
    shadowMd: "0 4px 16px rgba(0, 0, 0, 0.35)",
};

/** Home chrome — frosted cards over scene photos. */
export const wwHomeColorsRandom = {
    ...wwHomeColorsLight,
    background: "transparent",
    surface: "rgba(255, 255, 255, 0.95)",
    surfaceLight: "rgba(236, 242, 239, 0.98)",
    text: "#0b3d36",
    textMuted: "rgba(15, 61, 54, 0.68)",
    textSecondary: "rgba(15, 61, 54, 0.78)",
    primaryGlow: "#0f766e",
};

/**
 * @param {"light"|"dark"|"random"} theme
 */
export function resolveScreenshotPlayColors(theme) {
    if (theme === "dark") return wwPlayColorsDark;
    if (theme === "random") return wwPlayColorsRandom;
    return wwPlayColorsLight;
}
